import { lazyNamed } from 'src/utils/lazyNamed';
import { PDFStylesFormSearchParams } from './pages/PDFStylesForm/types';

export const CompanySettings = {
  // common
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  SalesUnitsProvider: lazyNamed(() => import('./components/SalesUnitsProvider'), 'SalesUnitsProvider'),

  // containers
  CoopWeeks: lazyNamed(() => import('./containers/CoopWeeks'), 'CoopWeeks'),
  PDFStyles: lazyNamed(() => import('./containers/PDFStyles'), 'PDFStyles'),
  PPTReportConfig: lazyNamed(() => import('./containers/PPTReportConfig'), 'PPTReportConfig'),
  Sequencing: lazyNamed(() => import('./containers/Sequencing'), 'Sequencing'),

  // pages
  EmailTemplateForm: lazyNamed(() => import('./pages/EmailTemplateForm'), 'EmailTemplateForm'),
  EmailTemplates: lazyNamed(() => import('./pages/EmailTemplates'), 'EmailTemplates'),
  PaymentDetails: lazyNamed(() => import('./pages/PaymentDetails'), 'PaymentDetails'),
  PaymentDetailsForm: lazyNamed(() => import('./pages/PaymentDetailsForm'), 'PaymentDetailsForm'),
  PDFFooterTemplates: lazyNamed(() => import('./pages/PDFFooterTemplates'), 'PDFFooterTemplates'),
  PDFStylesForm: lazyNamed(() => import('./pages/PDFStylesForm'), 'PDFStylesForm'),
  PDFStylesNew: lazyNamed(() => import('./pages/PDFStylesNew'), 'PDFStyles'),
  PDFTypeConfigurations: lazyNamed(() => import('./pages/PDFTypeConfigurations'), 'PDFTypeConfigurations'),

  // search params
  PDFStylesFormSearchParams,
};
